import type { MyMatch } from '@swiss-magic/shared-types';

// The raw result string is always written from the first player's
// perspective ("1-0" = first wins). Flip it when the viewer was the
// second player so their own score appears first.
const FLIPPED_RESULT: Record<string, string> = {
  '1-0': '0-1',
  '0-1': '1-0',
  '+/-': '-/+',
  '-/+': '+/-',
  '+--': '--+',
  '--+': '+--',
};

export function viewerResult(match: MyMatch): string {
  if (match.result === null) return '';
  if (match.isFirstPlayer) return match.result;
  return FLIPPED_RESULT[match.result] ?? match.result;
}
